export const fontSets = {
  corporate: {
    desktop: {
      fontFace: {
        h1: 'Noe Display',
        h2: 'Noe Display',
        h3: 'Noe Display',
        h4: 'Poppins',
        h5: 'Poppins',
        h6: 'Poppins',
        body: 'Poppins',
        bodyBold: 'Poppins',
        bodyLarge: 'Poppins',
        bodySmall: 'Poppins',
        blockquote: 'Poppins',
        blockquoteBold: 'Poppins',
        functional: 'Poppins',
      },
      fontSize: {
        h1: '44px',
        h2: '36px',
        h3: '30px',
        h4: '24px',
        h5: '18px',
        h6: '16px',
        body: '16px',
        bodyBold: '16px',
        bodyLarge: '18px',
        bodySmall: '14px',
        blockquote: '18px',
        blockquoteBold: '18px',
        functional: '16px',
      },
      lineHeight: {
        h1: '50px',
        h2: '42px',
        h3: '36px',
        h4: '30px',
        h5: '24px',
        h6: '22px',
        body: '24px',
        bodyBold: '24px',
        bodyLarge: '27px',
        bodySmall: '21px',
        blockquote: '27px',
        blockquoteBold: '27px',
        functional: '24px',
      },
      fontWeight: {
        h1: '700',
        h2: '700',
        h3: '700',
        h4: '500',
        h5: '600',
        h6: '600',
        body: '400',
        bodyBold: '600',
        bodyLarge: '400',
        bodySmall: '400',
        blockquote: '300',
        blockquoteBold: '500',
        functional: '500',
      },
      letterSpacing: {
        h1: '0.5px',
        h2: '0.5px',
        h3: '0.5px',
        h4: '0px',
        h5: '0px',
        h6: '0px',
        body: '0px',
        bodyBold: '0px',
        bodyLarge: '0px',
        bodySmall: '0px',
        blockquote: '0px',
        blockquoteBold: '0px',
        functional: '0px',
      },
    },
    tablet: {
      fontFace: {
        h1: 'Noe Display',
        h2: 'Noe Display',
        h3: 'Noe Display',
        h4: 'Poppins',
        h5: 'Poppins',
        h6: 'Poppins',
        body: 'Poppins',
        bodyBold: 'Poppins',
        bodyLarge: 'Poppins',
        bodySmall: 'Poppins',
        blockquote: 'Poppins',
        blockquoteBold: 'Poppins',
        functional: 'Poppins',
      },
      fontSize: {
        h1: '40px',
        h2: '32px',
        h3: '26px',
        h4: '22px',
        h5: '18px',
        h6: '16px',
        body: '16px',
        bodyBold: '16px',
        bodyLarge: '18px',
        bodySmall: '14px',
        blockquote: '17px',
        blockquoteBold: '17px',
        functional: '14px',
      },
      lineHeight: {
        h1: '48px',
        h2: '38px',
        h3: '32px',
        h4: '26px',
        h5: '24px',
        h6: '20px',
        body: '24px',
        bodyBold: '24px',
        bodyLarge: '27px',
        bodySmall: '21px',
        blockquote: '26px',
        blockquoteBold: '26px',
        functional: '24px',
      },
      fontWeight: {
        h1: '700',
        h2: '700',
        h3: '700',
        h4: '500',
        h5: '600',
        h6: '600',
        body: '400',
        bodyBold: '600',
        bodyLarge: '400',
        bodySmall: '400',
        blockquote: '300',
        blockquoteBold: '500',
        functional: '500',
      },
      letterSpacing: {
        h1: '0.5px',
        h2: '0.5px',
        h3: '0.5px',
        h4: '0px',
        h5: '0px',
        h6: '0px',
        body: '0px',
        bodyBold: '0px',
        bodyLarge: '0px',
        bodySmall: '0px',
        blockquote: '0px',
        blockquoteBold: '0px',
        functional: '0px',
      },
    },
    mobile: {
      fontFace: {
        h1: 'Noe Display',
        h2: 'Noe Display',
        h3: 'Noe Display',
        h4: 'Poppins',
        h5: 'Poppins',
        h6: 'Poppins',
        body: 'Poppins',
        bodyBold: 'Poppins',
        bodyLarge: 'Poppins',
        bodySmall: 'Poppins',
        blockquote: 'Poppins',
        blockquoteBold: 'Poppins',
        functional: 'Poppins',
      },
      fontSize: {
        h1: '36px',
        h2: '28px',
        h3: '22px',
        h4: '20px',
        h5: '18px',
        h6: '16px',
        body: '16px',
        bodyBold: '16px',
        bodyLarge: '18px',
        bodySmall: '14px',
        blockquote: '16px',
        blockquoteBold: '16px',
        functional: '16px',
      },
      lineHeight: {
        h1: '42px',
        h2: '34px',
        h3: '28px',
        h4: '26px',
        h5: '24px',
        h6: '22px',
        body: '24px',
        bodyBold: '24px',
        bodyLarge: '27px',
        bodySmall: '21px',
        blockquote: '24px',
        blockquoteBold: '24px',
        functional: '24px',
      },
      fontWeight: {
        h1: '700',
        h2: '700',
        h3: '700',
        h4: '500',
        h5: '600',
        h6: '600',
        body: '400',
        bodyBold: '600',
        bodyLarge: '400',
        bodySmall: '400',
        blockquote: '300',
        blockquoteBold: '500',
        functional: '500',
      },
      letterSpacing: {
        h1: '2px',
        h2: '0.5px',
        h3: '0.5px',
        h4: '0px',
        h5: '0px',
        h6: '0px',
        body: '0px',
        bodyBold: '0px',
        bodyLarge: '0px',
        bodySmall: '0px',
        blockquote: '0px',
        blockquoteBold: '0px',
        functional: '0px',
      },
    },
  },
  modern: {
    desktop: {
      fontFace: {
        h1: 'Poppins',
        h2: 'Poppins',
        h3: 'Poppins',
        h4: 'Poppins',
        h5: 'Poppins',
        h6: 'Poppins',
        body: 'Poppins',
        bodyBold: 'Poppins',
        bodyLarge: 'Poppins',
        bodySmall: 'Poppins',
        blockquote: 'Poppins',
        blockquoteBold: 'Poppins',
        functional: 'Poppins',
      },
      fontSize: {
        h1: '40px',
        h2: '34px',
        h3: '28px',
        h4: '24px',
        h5: '18px',
        h6: '16px',
        body: '16px',
        bodyBold: '16px',
        bodyLarge: '18px',
        bodySmall: '14px',
        blockquote: '18px',
        blockquoteBold: '18px',
        functional: '16px',
      },
      lineHeight: {
        h1: '46px',
        h2: '40px',
        h3: '34px',
        h4: '30px',
        h5: '24px',
        h6: '22px',
        body: '24px',
        bodyBold: '24px',
        bodyLarge: '27px',
        bodySmall: '21px',
        blockquote: '27px',
        blockquoteBold: '27px',
        functional: '24px',
      },
      fontWeight: {
        h1: '500',
        h2: '500',
        h3: '500',
        h4: '500',
        h5: '600',
        h6: '600',
        body: '400',
        bodyBold: '600',
        bodyLarge: '400',
        bodySmall: '400',
        blockquote: '300',
        blockquoteBold: '500',
        functional: '500',
      },
      letterSpacing: {
        h1: '-0.25px',
        h2: '-0.25px',
        h3: '-0.25px',
        h4: '-0.25px',
        h5: '-0.25px',
        h6: '-0.25px',
        body: '0px',
        bodyBold: '0px',
        bodyLarge: '0px',
        bodySmall: '0px',
        blockquote: '0px',
        blockquoteBold: '0px',
        functional: '0px',
      },
    },
    tablet: {
      fontFace: {
        h1: 'Poppins',
        h2: 'Poppins',
        h3: 'Poppins',
        h4: 'Poppins',
        h5: 'Poppins',
        h6: 'Poppins',
        body: 'Poppins',
        bodyBold: 'Poppins',
        bodyLarge: 'Poppins',
        bodySmall: 'Poppins',
        blockquote: 'Poppins',
        functional: 'Poppins',
      },
      fontSize: {
        h1: '38px',
        h2: '32px',
        h3: '26px',
        h4: '22px',
        h5: '18px',
        h6: '16px',
        body: '16px',
        bodyBold: '16px',
        bodyLarge: '18px',
        bodySmall: '14px',
        blockquote: '17px',
        blockquoteBold: '17px',
        functional: '14px',
      },
      lineHeight: {
        h1: '48px',
        h2: '38px',
        h3: '32px',
        h4: '28px',
        h5: '24px',
        h6: '22px',
        body: '24px',
        bodyBold: '24px',
        bodyLarge: '27px',
        bodySmall: '21px',
        blockquote: '26px',
        blockquoteBold: '26px',
        functional: '24px',
      },
      fontWeight: {
        h1: '500',
        h2: '500',
        h3: '500',
        h4: '500',
        h5: '600',
        h6: '600',
        body: '400',
        bodyBold: '600',
        bodyLarge: '400',
        bodySmall: '400',
        blockquote: '300',
        blockquoteBold: '500',
        functional: '500',
      },
      letterSpacing: {
        h1: '-0.25px',
        h2: '-0.25px',
        h3: '-0.25px',
        h4: '-0.25px',
        h5: '-0.25px',
        h6: '-0.25px',
        body: '0px',
        bodyBold: '0px',
        bodyLarge: '0px',
        bodySmall: '0px',
        blockquote: '0px',
        blockquoteBold: '0px',
        functional: '0px',
      },
    },
    mobile: {
      fontFace: {
        h1: 'Poppins',
        h2: 'Poppins',
        h3: 'Poppins',
        h4: 'Poppins',
        h5: 'Poppins',
        h6: 'Poppins',
        body: 'Poppins',
        bodyBold: 'Poppins',
        bodyLarge: 'Poppins',
        bodySmall: 'Poppins',
        blockquote: 'Poppins',
        functional: 'Poppins',
      },
      fontSize: {
        h1: '36px',
        h2: '28px',
        h3: '22px',
        h4: '20px',
        h5: '18px',
        h6: '16px',
        body: '16px',
        bodyBold: '16px',
        bodyLarge: '18px',
        bodySmall: '14px',
        blockquote: '16px',
        blockquoteBold: '16px',
        functional: '16px',
      },
      lineHeight: {
        h1: '42px',
        h2: '34px',
        h3: '28px',
        h4: '26px',
        h5: '24px',
        h6: '22px',
        body: '24px',
        bodyBold: '24px',
        bodyLarge: '27px',
        bodySmall: '21px',
        blockquote: '24px',
        blockquoteBold: '24px',
        functional: '24px',
      },
      fontWeight: {
        h1: '500',
        h2: '500',
        h3: '500',
        h4: '500',
        h5: '600',
        h6: '600',
        body: '400',
        bodyBold: '600',
        bodyLarge: '400',
        bodySmall: '400',
        blockquote: '300',
        blockquoteBold: '500',
        functional: '500',
      },
      letterSpacing: {
        h1: '-0.25px',
        h2: '-0.25px',
        h3: '-0.25px',
        h4: '-0.25px',
        h5: '-0.25px',
        h6: '-0.25px',
        body: '0px',
        bodyBold: '0px',
        bodyLarge: '0px',
        bodySmall: '0px',
        blockquote: '0px',
        blockquoteBold: '0px',
        functional: '0px',
      },
    },
  },
};
